import React from 'react'
import { Link } from '@mui/material'
import theme from 'theme'

export default function ButtonLink(props) {
  return (
    <Link
      {...props}
      component="button"
      color={props.disabled ? theme.palette.text.disabled : props.color}
      sx={{ cursor: props.disabled ? 'initial' : undefined, ...props?.sx }}
    />
  )
}
